export const VolumeSlider = {
  mounted() {
    this.hovering = false;
    this.loadVolumePreference();
    this.setupEventListener();
    this.setupHoverListener();
    this.syncAutoCollapse();
  },

  updated() {
    const volume = this.el.dataset.volume;
    const muted = this.el.dataset.muted;

    this.saveVolumePreference(volume, muted);
    this.syncAutoCollapse();
  },

  destroyed() {
    this.clearCollapseTimer();
    this.cleanup?.();
    this.cleanupHover?.();
  },

  setupEventListener() {
    const boundHandleInput = this.handleInput.bind(this);

    this.el.addEventListener("input", boundHandleInput);

    this.cleanup = () => {
      this.el.removeEventListener("input", boundHandleInput);
    };
  },

  setupHoverListener() {
    const zone = document.getElementById("volume-control");
    if (!zone) return;

    const onEnter = () => {
      this.hovering = true;
      this.clearCollapseTimer();
    };

    const onLeave = () => {
      this.hovering = false;
      if (this.el.dataset.expanded === "true") {
        this.resetCollapseTimer();
      }
    };

    zone.addEventListener("mouseenter", onEnter);
    zone.addEventListener("mouseleave", onLeave);

    this.cleanupHover = () => {
      zone.removeEventListener("mouseenter", onEnter);
      zone.removeEventListener("mouseleave", onLeave);
    };
  },

  handleInput(e) {
    const volume = e.target.value;
    this.pushEvent("update_volume", { volume });
    this.clearCollapseTimer();
  },

  syncAutoCollapse() {
    if (this.el.dataset.expanded === "true") {
      if (!this.hovering) {
        this.resetCollapseTimer();
      }
    } else {
      this.clearCollapseTimer();
    }
  },

  resetCollapseTimer() {
    this.clearCollapseTimer();
    const ms = parseInt(this.el.dataset.autoCollapseMs || "2000", 10);
    if (!ms || ms <= 0) return;
    this.collapseTimer = setTimeout(() => {
      this.collapseTimer = null;
      if (this.el.dataset.expanded === "true") {
        this.pushEvent("toggle_volume_controls");
      }
    }, ms);
  },

  clearCollapseTimer() {
    if (this.collapseTimer) {
      clearTimeout(this.collapseTimer);
      this.collapseTimer = null;
    }
  },

  loadVolumePreference() {
    const { volume, muted } = this.getVolumePreference();

    if (volume !== null && muted !== null) {
      this.pushEvent("initialize_volume", { volume, muted });
    }
  },

  saveVolumePreference(value, muted) {
    localStorage.setItem("tvlabs:access:volume", value);
    localStorage.setItem("tvlabs:access:muted", muted);
  },

  getVolumePreference() {
    return {
      volume: localStorage.getItem("tvlabs:access:volume"),
      muted: localStorage.getItem("tvlabs:access:muted"),
    };
  },
};
